import { PaperReferralApprovalResult } from '@dreryk/egabinet-referral-frontend-api';
import { VisitReferralToPsychiatricHospitalApproveCommand } from '@dreryk/egabinet-visit-frontend-api';

import { useCqrsCommand } from '@dreryk/command-query-react-common';
import { PromiseVoidFunction } from '@dreryk/react-common';
import { ActionBar, ButtonVariant } from '@dreryk/react-components';
import { useDraftRemoveByTokenCqrsCommand } from '@dreryk/react-draft';

import { getReferralDraftToken } from '../../referral.draft';
import { useReferralPrintCommandSuccessHandler } from '../../shared/useReferralPrintCommandSuccessHandler';
import { referralTranslationKeys } from '../../translations';
import {
   ReferralToPsychiatricHospitalFormBean,
   ReferralToPsychiatricHospitalFormController,
} from '../ReferralToPsychiatricHospitalForm/referralToPsychiatricHospitalForm.types';
import { mapReferralToPsychiatricFormBeanToCommandDetails } from '../ReferralToPsychiatricHospitalForm/ReferralToPsychiatricHospitalForm.utils';

type ReferralToRehabilitationSendActionProps = {
   readonly handleSubmit: ReferralToPsychiatricHospitalFormController['handleSubmit'];
   readonly visitId: number;
   readonly onSuccess: PromiseVoidFunction | VoidFunction;
};

export const ReferralToPsychiatricHospitalSendAction = (
   props: ReferralToRehabilitationSendActionProps
): JSX.Element => {
   const handlePrintSuccess = useReferralPrintCommandSuccessHandler({
      visitId: props.visitId,
      onPrintDone: props.onSuccess,
   });

   const { executeAsync: removeDraft } = useDraftRemoveByTokenCqrsCommand();

   const { executeAsync: sendReferralToPsychiatricHospital } = useCqrsCommand<
      PaperReferralApprovalResult,
      ReferralToPsychiatricHospitalFormBean
   >(
      (parameters) => {
         const command = new VisitReferralToPsychiatricHospitalApproveCommand();
         command.visitId = props.visitId;
         command.referralDetails = mapReferralToPsychiatricFormBeanToCommandDetails(parameters);
         return command;
      },
      {
         onSuccess: async (result) => {
            handlePrintSuccess(result);
            await removeDraft({ token: getReferralDraftToken('referralToPsychiatricHospital', props.visitId) });
         },
      }
   );
   return (
      <ActionBar.PrimaryButton
         variant={ButtonVariant.PRIMARY}
         onClick={props.handleSubmit(sendReferralToPsychiatricHospital)}
         label={referralTranslationKeys.actionBar.confirmAndPrint}
         testId={'confirmAndPrint'}
         blockingOperation
      />
   );
};
